module.exports = __webpack_public_path__ + "assets/4c5181fe9fca1d49e106bdbe9485e209.png";